var _g, _path, _g2, _g3, _g4, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSadSmiley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 74,
    viewBox: "0 0 76 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_6493_36907)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.2204,
    cy: 34.0133,
    r: 30.1774,
    fill: "#FFDE67"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.3858 34.8179C65.3858 31.1191 64.6573 27.4566 63.2418 24.0394C61.8264 20.6222 59.7517 17.5173 57.1363 14.9018C54.5209 12.2864 51.4159 10.2118 47.9987 8.79632C44.5815 7.38087 40.919 6.65234 37.2202 6.65234C33.5215 6.65234 29.859 7.38087 26.4418 8.79632C23.0245 10.2118 19.9196 12.2864 17.3042 14.9018C14.6888 17.5173 12.6141 20.6222 11.1987 24.0394C9.78321 27.4566 9.05469 31.1192 9.05469 34.8179L37.2202 34.8179H65.3858Z",
    fill: "url(#paint0_linear_6493_36907)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_6493_36907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99215 42.9921C11.0417 46.5388 12.7795 49.8441 15.1065 52.7192C17.4334 55.5943 20.3038 57.9829 23.5539 59.7487C26.8039 61.5144 30.3699 62.6228 34.0483 63.0104C37.7267 63.398 41.4454 63.0573 44.9921 62.0078C48.5389 60.9582 51.8441 59.2204 54.7192 56.8935C57.5943 54.5665 59.983 51.6961 61.7487 48.4461C63.5145 45.196 64.6228 41.63 65.0105 37.9516C65.3981 34.2732 65.0574 30.5545 64.0079 27.0078L37 34.9999L9.99215 42.9921Z",
    fill: "url(#paint1_linear_6493_36907)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_6493_36907)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.2512,
    cy: 25.8684,
    r: 3.52069,
    fill: "#352121"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_6493_36907)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.2517,
    cy: 24.4587,
    r: 1.17356,
    fill: "#FFF850"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_6493_36907)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48.5871,
    cy: 25.8684,
    r: 3.52069,
    fill: "#352121"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_6493_36907)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48.5876,
    cy: 24.4587,
    r: 1.17356,
    fill: "#FFF850"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5028 51.2068C51.7012 51.7349 52.3312 51.5988 52.228 51.0442C51.6696 48.0465 50.2149 45.2624 48.0233 43.0761C45.167 40.2267 41.2931 38.626 37.2538 38.626C33.2144 38.626 29.3406 40.2267 26.4843 43.0761C24.2788 45.2763 22.8195 48.0818 22.2691 51.1012C22.1679 51.6565 22.8097 51.7841 23.0131 51.2576C28.048 38.2242 46.59 38.1268 51.5028 51.2068Z",
    fill: "#352121"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_6493_36907",
    x: -22.957,
    y: -56.1641,
    width: 90.3555,
    height: 120.355,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -30,
    dy: -60
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.72 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6493_36907"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_6493_36907",
    x: -0.0078125,
    y: 17.0078,
    width: 75.1719,
    height: 56.1562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_6493_36907"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_6493_36907",
    x: 21.7305,
    y: 22.3477,
    width: 7.04297,
    height: 12.043,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6493_36907"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_6493_36907",
    x: 11.0781,
    y: 10.2852,
    width: 28.3477,
    height: 28.3477,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5,
    result: "effect1_foregroundBlur_6493_36907"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_6493_36907",
    x: 45.0664,
    y: 22.3477,
    width: 7.04297,
    height: 12.043,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6493_36907"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_6493_36907",
    x: 34.4141,
    y: 10.2852,
    width: 28.3477,
    height: 28.3477,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5,
    result: "effect1_foregroundBlur_6493_36907"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6493_36907",
    x1: 37.2202,
    y1: 6.65234,
    x2: 37.2202,
    y2: 30.7943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6493_36907",
    x1: 46.2887,
    y1: 60.1154,
    x2: 38.4543,
    y2: 38.8815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D36500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadSmiley);
export default __webpack_public_path__ + "static/media/sad-smiley.7c615265284951800ef011bdb52787ee.svg";
export { ForwardRef as ReactComponent };